var App = App || {};

App.Bios = (() => {
    'use strict';

    const init = (id) => {
        const bios = document.getElementById(id);
        const modal = document.getElementById(`${id}-modal`)
        const bsModal = new bootstrap.Modal(modal);

        bios.querySelectorAll('.bio-card').forEach(card => {
            card.addEventListener('click', e => {
                e.preventDefault();

                let details = document.getElementById(card.href.split('#')[1]);
                let modalBody = modal.querySelector('.modal-body');

                if (modalBody.firstChild) {
                    bios.appendChild(modalBody.firstChild);
                }

                modalBody.appendChild(details);
                bsModal.show();
            });
        });
    }

    return {
        init: init
    };
})();